import {WOW} from  'wowjs/dist/wow.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    $.lazyLoadXT.onload.addClass = 'animated fadeIn delay-1s';

    //Menu toggle
    $('.menu_toggle').on('click', function(){
      $(this).toggleClass('opened');
      $('.header_nav').toggleClass('open');
      $('#responsive-menu-wrapper').slideToggle();
    });

    $('.wrapper .close_btn').on('click', function(){
      $('.header_nav').removeClass('open');
      $('#responsive-menu-wrapper').slideToggle();
    });

    // Owl Carousel
    $('#banner_slider').owlCarousel({
      loop: true,
      nav:true,
      items: 1,
    });

    var owl = $('#slider_info').owlCarousel({
      // navText : ['Learners','Employers','Apprentices'],
      smartSpeed: 1000,
      nav:true,
      margin:15,
      loop: false,
      items: 1,
      dots: true,
      dotsData: true,
    });

    $( '.owl-dot' ).on( 'click', function() {
      owl.trigger('to.owl.carousel', [$(this).index(), 300]);
      $( '.owl-dot' ).removeClass( 'active' );
      $(this).addClass( 'active' );
    })

    $('#testimonies').owlCarousel({
      autoplaySpeed: 1000,
      autoplay: true,
      nav:true,
      loop: true,
      items: 1,
    });

    $('.www_carousel').owlCarousel({
      autoplay: true,
      autoWidth:true,
      nav:false,
      margin: 20,
      loop: true,
      responsive : {
        425 : {
          items: 4,
        },
        0 : {
          margin: 55,
          items: 2,
        },
      },
    });
    
    //auto height 
    $('.dl_lists .title').matchHeight();
    $('.dl_lists .sub_heading').matchHeight();
    $('.dl_lists .downloads .col-12 .file').matchHeight();

    const wow = new WOW({
      boxClass: 'wow',
      live: false,
      mobile: false,
    });
    wow.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var current = location.pathname;
    $('.nav-primary #menu-primary-navigation li a').each(function(){
        var $this = $(this);
        // if the current path is like this link, make it active
        if($this.attr('href').indexOf(current) !== -1){
          $this.addClass('active');
        }
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js